import React, { useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import "./App.css";
import NavBar from "./components/navbar";
import HelpPage from "./components/helpPage";
import BattleGroundDetails from "./components/battleGroundDetails";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Box from "@mui/material/Box";

// Create theme once outside of component to avoid recreation on every render
const theme = createTheme({
    typography: {
        fontFamily: "Josefin Sans, Arial, sans-serif",
    },
});

const App = () => {
    return (
        <ThemeProvider theme={theme}>
            <NavBar />
            <Box 
                className="containers"
                sx={{
                    width: "75%",         // Full width
                    maxWidth: "3000px",    // Much larger maximum width
                    minWidth: "1200px", // Add minimum width to prevent too narrow layouts

                    margin: "0 auto",      
                    padding: "8px 0 0 0",          // No padding
                }}
            >
                <Routes>
                    <Route path="/help" element={<HelpPage />} />
                    <Route path="/" element={<BattleGroundDetails />} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </Box>
        </ThemeProvider>
    );
};

export default App;
